// src/redux/reducers/siteReducer.js
import { SET_TEMP_NAME } from "../actions/tempnameAction";

const initialState = {
    tempnameList: [],
};

const tempnameReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TEMP_NAME:
      return {
        ...state,
        tempnameList: action.payload,
      };
    default:
      return state;
  }
};

export default tempnameReducer;
